// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-edit-translation .Ccm-Page {
  min-width: 200px;
}
.fi-edit-translation .input-wrapper {
  width: 100%;
}
.fi-edit-translation .input-wrapper .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/edit-translation/edit-translation.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,WAAA;AADR;AAEQ;EACI,WAAA;AAAZ","sourcesContent":[".fi-edit-translation {\r\n    .Ccm-Page {\r\n        min-width: 200px;\r\n    }\r\n\r\n    .input-wrapper {\r\n        width: 100%;\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
